/**
 * Test IDs for QA automation.
 */
export const testIds = {
  trailerProfileFormRemoveCompartment: "trailer-profile-form-remove-compartment",
  trailerProfileFormAddCompartment: "trailer-profile-form-add-compartment",
  trailerProfileFormLabel: "trailer-profile-form-label",
  trailerProfileFormCapacity: "trailer-profile-form-capacity",
  trailerProfileFormMaxWeight: "trailer-profile-form-max-weight",
  trailerProfileFormMinUsage: "trailer-profile-form-min-usage",
} as const;
